"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ShowReviews;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

ShowReviews.defaultProps = {
  showZeroReviews: true
};

function ShowReviews(props) {
  var numReviews = props.numReviews,
      showZeroReviews = props.showZeroReviews,
      rest = (0, _objectWithoutProperties2["default"])(props, ["numReviews", "showZeroReviews"]);
  if (!showZeroReviews && !numReviews) return null;
  if (showZeroReviews && !numReviews) numReviews = 0;
  return _react["default"].createElement("p", (0, _extends2["default"])({
    className: "review-counter"
  }, rest), numReviews, " ", numReviews !== 1 ? 'Reviews' : 'Review');
}